<div class="image-modal-overlay" (click)="closeModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
        <div class="image-container" #imageContainer *ngIf="fileObjects && fileObjects[currentIndex]">
            <img [src]="fileObjects[currentIndex].url" alt="Maximized Image" #image (load)="onImageLoad()"
                [class.animating]="animateTransform">
            <!-- Canvas for drawing and text annotations with mouse and touch events -->
            <canvas #canvasOverlay class="annotation-canvas" [class.edit-mode]="editMode"
                [class.animating]="animateTransform"
                (mousedown)="onCanvasMouseDown($event)"
                (mousemove)="onCanvasMouseMove($event)" (mouseup)="onCanvasMouseUp($event)"
                (mouseleave)="onCanvasMouseUp($event)" (dblclick)="onCanvasDblClick($event)"
                (touchstart)="onCanvasTouchStart($event)" (touchmove)="onCanvasTouchMove($event)"
                (touchend)="onCanvasTouchEnd($event)">
            </canvas>
        </div>

        <!-- Drawing Controls (visible only in edit mode) -->
        <div class="drawing-controls" *ngIf="editMode">
            <div class="annotation-controls">

                <div class="color-fields">
                    <p class="color-label">Draw</p>
                    <ngx-colors matTooltip="Set the drawing color" ngx-colors-trigger [(ngModel)]="drawingColor"
                        [hideTextInput]="true" class="color-picker"></ngx-colors>
                </div>

                <mat-form-field appearance="outline" class="compact-field">
                    <mat-label>Stroke</mat-label>
                    <input matInput [(ngModel)]="strokeWidth" type="number" min="1">
                </mat-form-field>


                <div class="color-fields">
                    <p class="color-label">Text</p>
                    <ngx-colors matTooltip="Set the text color" ngx-colors-trigger [(ngModel)]="textColor"
                        [hideTextInput]="true" class="color-picker"></ngx-colors>
                </div>

                <mat-form-field appearance="outline" class="compact-field">
                    <mat-label>Font</mat-label>
                    <input matInput [(ngModel)]="fontSize" type="number" min="8">
                </mat-form-field>

            </div>
            <div class="drawing-buttons">
                <button mat-icon-button (click)="toggleAddText()"
                    [color]="addingText ? 'primary' : ''"
                    matTooltip="Add text — tap on the image to place">
                    <mat-icon>text_fields</mat-icon>
                </button>
                <button mat-icon-button (click)="undoAnnotation()">
                    <mat-icon>undo</mat-icon>
                </button>
                <button mat-icon-button (click)="redoAnnotation()">
                    <mat-icon>redo</mat-icon>
                </button>
                <button mat-icon-button (click)="clearAnnotations()">
                    <mat-icon>restart_alt</mat-icon>
                </button>
                <button mat-icon-button (click)="saveDrawing()" [disabled]="isUploading">
                    <ng-container *ngIf="!isUploading; else spinner">
                        <mat-icon>save</mat-icon>
                    </ng-container>
                    <ng-template #spinner>
                        <mat-progress-spinner color="primary" diameter="24" mode="indeterminate" strokeWidth="3"
                            style="display: inline-block;">
                        </mat-progress-spinner>
                    </ng-template>
                </button>
                <button mat-icon-button (click)="cancelDrawing()">
                    <mat-icon>close</mat-icon>
                </button>

            </div>
        </div>

        <div class="position" *ngIf="!editMode && position" aria-live="polite">{{ position }}</div>

        <!-- Normal Gallery Controls (hidden in edit mode) -->
        <div class="controls" *ngIf="!editMode">
            <button mat-icon-button (click)="previousFile()" *ngIf="fileObjects && fileObjects.length > 1" aria-label="Previous image">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-icon-button (click)="nextFile()" *ngIf="fileObjects && fileObjects.length > 1" aria-label="Next image">
                <mat-icon>chevron_right</mat-icon>
            </button>
            <button mat-icon-button (click)="zoomIn()">
                <mat-icon>zoom_in</mat-icon>
            </button>
            <button mat-icon-button (click)="zoomOut()">
                <mat-icon>zoom_out</mat-icon>
            </button>
            <button mat-icon-button (click)="resetZoom()">
                <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button (click)="rotateLeft()">
                <mat-icon>rotate_left</mat-icon>
            </button>
            <button mat-icon-button (click)="rotateRight()">
                <mat-icon>rotate_right</mat-icon>
            </button>
            <button mat-icon-button (click)="downloadFile()">
                <mat-icon>download</mat-icon>
            </button>
            <!-- Edit button to enable drawing mode -->
            <button mat-icon-button (click)="enableEditMode()" *ngIf="enableEditing && imageType === 'note'">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>